<template>
  <div class="loading-dialog">
    <div class="img-box">
      <img :src="require('../../assets/images/loading.gif')" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/loading.vue